import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var SITE_ARI_REGEX = new RegExp('ari:cloud:(.+)::site/(.+)');

/**
 * This util should not throw error and should resolve to defaults for invalid input.
 *
 * @param ari
 * @returns product and id from the ari
 */
export var parseSiteARI = function parseSiteARI(ari) {
  if (!ari) {
    return {
      product: '',
      id: ''
    };
  }
  var _Array$from = Array.from(ari.match(SITE_ARI_REGEX) || ['', '', '']),
    _Array$from2 = _slicedToArray(_Array$from, 3),
    _original = _Array$from2[0],
    product = _Array$from2[1],
    id = _Array$from2[2];
  return {
    product: product,
    id: id
  };
};